import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#3f51b5',   // Azul
          secondary: '#673ab7', // Roxo
          accent: '#00bcd4',    // Azul claro
          error: '#f44336',     // Vermelho
          info: '#2196f3',      // Azul informativo
          success: '#4caf50',   // Verde
          warning: '#ff9800',   // Laranja
        }
      }
    }
  }
})

export default vuetify